import type { PropsWithChildren } from 'react';

import { PopoverButtonGroup, PopoverFooter } from '@frontend/components';

export type FiltersButtonsWrapperProps = PropsWithChildren<unknown>;

export const FiltersButtonsWrapper = ({
  children,
}: FiltersButtonsWrapperProps) => {
  return (
    <PopoverFooter>
      <PopoverButtonGroup>{children}</PopoverButtonGroup>
    </PopoverFooter>
  );
};
